(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-rewards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swipers = document.querySelectorAll('.about-rewards__swiper');
    
    swipers.forEach(swiperEl => {
      const slides = swiperEl.querySelectorAll('.swiper-slide');

      new Swiper(swiperEl, {
        slidesPerView: 1.1,
        spaceBetween: 0,
        loop: true,
        speed: 500,
        allowTouchMove: true,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["awards-list-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let swiper = new Swiper('.awards-list-section__mobile', {
      spaceBetween: 30,
      slidesPerView: 'auto',
      
      // iOS-specific fixes
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      allowTouchMove: true,
      
      // Better touch handling for iOS
      touchStartPreventDefault: false,
      touchStartForcePreventDefault: false,
      touchMoveStopPropagation: false,
      
      // Improved free mode for iOS
      freeMode: {
        enabled: true,
        minimumVelocity: 0.1,
        momentumBounce: false,
        momentumRatio: 0.5,
        momentumVelocityRatio: 0.5,
        sticky: false,
      },
      
      // Better pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: false,
      },
      
      // iOS-specific event handling
      on: {
        touchStart: function() {
          // Prevent default only when necessary
          if (this.touchStartPreventDefault) {
            return false;
          }
        },
        touchMove: function() {
          // Allow natural scrolling
          return true;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridal-grid-section"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.bridal-grid-section__slider');

    sliders.forEach((sliderEl) => {
      new Swiper(sliderEl, {
        spaceBetween: 2,
        slidesPerView: 'auto',
        breakpoints: {
          744: {
            spaceBetween: 4,
          },
          1030: {
            spaceBetween: 8,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.category-slider-section').forEach((section) => {
    const swipers = section.querySelectorAll('.category-swiper');

    swipers.forEach((swiperEl) => {
      new Swiper(swiperEl, {
        spaceBetween: 1,
        slidesPerView: 1.5,
        grabCursor: true,
        breakpoints: {
          744: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 2.6,
          },
          1200: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });

    const categoryTabs = section.querySelectorAll('.category-slider-section__tab');
    const categorySliders = section.querySelectorAll('.category-slider-section__slider');

    if (categoryTabs.length > 0 && categorySliders.length > 0) {
      categoryTabs[0].classList.add('tab-selected');
      categorySliders[0].classList.add('category-slider-section__slider--active');
    }

    categoryTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;

        categoryTabs.forEach((t) => t.classList.remove('tab-selected'));
        tab.classList.add('tab-selected');

        categorySliders.forEach((slider) => {
          if (slider.dataset.tab === targetTab) {
            slider.classList.add('category-slider-section__slider--active');
          } else {
            slider.classList.remove('category-slider-section__slider--active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experience-section"] && !Shopify.designMode) return;
  try {
    
  // Marquee animation is now handled by CSS
  // No JavaScript needed for the infinite scroll effect

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feed-section"] && !Shopify.designMode) return;
  try {
    
  // Marquee animation is now handled by CSS
  // No JavaScript needed for the infinite scroll effect

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animated-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const isDesktop = window.innerWidth >= 1030;

    console.log('Process Animated Section Loaded', window.innerWidth);
    if (isDesktop) {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.hero-animated-section__container',
          start: 'top top',
          end: '+=100%',
          scrub: true,
        },
      });
      tl.fromTo(
        '.hero-animated-section__sticky',
        {
          width: '100%',
          height: '100vh',
        },
        {
          width: '41.7245%',
          height: '100vh',
          ease: 'power2',
        },
        '0.2'
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);
    const isDesktop = window.innerWidth > 1030;
    const isTablet = window.innerWidth <= 1030 && window.innerWidth > 600;

    if (isDesktop) {
      let isPlayEnabled = true;

      window.addEventListener('scroll', function () {
        const newScrollPos = window.scrollY;
        if (newScrollPos > 300 && isPlayEnabled && newScrollPos < window.innerHeight) {
          window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth',
          });
          return;
        }

        if (newScrollPos >= window.innerHeight) {
          isPlayEnabled = false;
          return;
        }

        if (newScrollPos <= 300) {
          isPlayEnabled = true;
        }
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.hero-container',
          start: 'top top',
          end: '+=100%',
          pin: true,
          scrub: 1,
        },
      });

      tl.fromTo(
        '.hero-banner',
        { width: '100%', height: '100lvh' },
        { width: '33%', height: '100lvh', paddingTop: 44, paddingBottom: 8, ease: 'none' }
      );
      tl.fromTo(
        '.hero-banner img',
        {
          objectPosition: 'center center',
        },
        {
          objectPosition: '70% 0',
          ease: 'power2.out',
        },
        '<0.02'
      );
      tl.fromTo('.sub-banner', { opacity: 0, y: 400 }, { opacity: 1, y: 0, ease: 'power2.in' }, '<0.2');
      tl.fromTo(
        '.hero-home-section__text h2',
        {
          fontSize: '56px',
        },
        {
          fontSize: '44px',
          ease: 'power2.out',
        },
        '<0.1'
      );
      tl.fromTo(
        '.hero-main__text',
        {
          bottom: '50%',
          yPercent: 50,
          gap: '32px',
        },
        {
          bottom: '7.9%',
          yPercent: 0,
          gap: '16px',
          ease: 'power2.out',
        },
        '<0.1'
      );
      tl.fromTo(
        '.hero-left__text, .hero-right__text',
        {
          bottom: '0',
          gap: '32px',
        },
        {
          bottom: '7.9%',
          gap: '16px',
          ease: 'power2.out',
        },
        '<0.2'
      );
      tl.fromTo(
        '.hero-home-section__text a',
        {
          fontSize: '20px',
        },
        {
          fontSize: '14px',
          ease: 'power2.out',
        },
        '<0.1'
      );
    } else {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: '.home-hero-section',
          start: 'top top',
          end: '+=100%',
          scrub: 1.5,
          pin: true,
        },
      });

      if (isTablet) {
        tl.fromTo('.hero-banner', { height: '100lvh' }, { height: '60lvh', ease: 'none' });
        tl.fromTo('.sub-banner', { opacity: 0.6, y: 50 }, { opacity: 1, y: 0, ease: 'none' }, '<-0.01');
        tl.fromTo(
          '.hero-main__text',
          {
            bottom: '120px',
            gap: '24px',
          },
          {
            bottom: '56px',
            gap: '22px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-main__text h2',
          {
            fontSize: '56px',
          },
          {
            fontSize: '44px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-main__text a',
          {
            fontSize: '20px',
          },
          {
            fontSize: '14px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-left__text, .hero-right__text',
          {
            bottom: '0',
          },
          {
            bottom: '56px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-wrapper .home-hero-section__banner',
          {
            padding: '0',
          },
          {
            padding: '8px',
            paddingBottom: '0',
            ease: 'power2.out',
          },
          '<0.1'
        );
      } else {
        tl.fromTo('.hero-banner', { height: '100lvh' }, { height: '40lvh', ease: 'none' });
        tl.fromTo('.sub-banner', { opacity: 0.6, y: 50 }, { opacity: 1, y: 0, stagger: 0.1, ease: 'none' }, '<-0.05');
        tl.fromTo(
          '.hero-main__text',
          {
            bottom: '72px',
            gap: '20px',
          },
          {
            bottom: '32px',
            gap: '10',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-main__text h2',
          {
            fontSize: '32px',
          },
          {
            fontSize: '24px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-main__text a',
          {
            fontSize: '15px',
          },
          {
            fontSize: '13px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-left__text, .hero-right__text',
          {
            bottom: '0',
          },
          {
            bottom: '32px',
            ease: 'power2.out',
          },
          '<0.1'
        );
        tl.fromTo(
          '.hero-wrapper .home-hero-section__banner',
          {
            padding: '0',
          },
          {
            padding: '1px',
            paddingBottom: '0',
            ease: 'power2.out',
          },
          '<0.1'
        );
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-section"] && !Shopify.designMode) return;
  try {
    
  // Marquee animation is now handled by CSS
  // No JavaScript needed for the infinite scroll effect

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.customer-account-section__tab');
    const tabContents = document.querySelectorAll('.customer-account-section__tab-content');

    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        const target = this.dataset.tabContent;
        window.location.hash = this.dataset.hash;

        tabs.forEach((t) => t.classList.remove('customer-account-section__tab--active', 'tag--selected'));
        tabContents.forEach((c) => c.classList.remove('customer-account-section__tab-content--active'));

        this.classList.add('customer-account-section__tab--active', 'tag--selected');
        document
          .querySelector(`.customer-account-section__tab-content[data-tab-content="${target}"]`)
          .classList.add('customer-account-section__tab-content--active');
      });
    });

    const container = document.querySelector('.customer-info__shipping-addresses');

    const updateAddresses = () => {
      fetch('/account', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((r) => r.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newBlock = doc.querySelector('.customer-info__shipping-addresses');
          document.querySelector('.customer-info__shipping-addresses').innerHTML = newBlock.innerHTML;
        });
    };

    container.addEventListener('submit', async (e) => {
      e.preventDefault();
      const form = e.target;

      const response = await fetch(form.action, {
        method: form.method,
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (response.ok) {
        updateAddresses();
      } else {
        console.error('Error updating address');
      }
    });

    const selectTab = () => {
      const hash = window.location.hash || 'loyalty';
      const targetButton = document.querySelector(
        `.customer-account-section__tab[data-hash="${hash.replace('#', '')}"]`
      );

      if (targetButton) {
        targetButton.click();
      }
    };

    window.addEventListener('hashchange', () => {
      window.scrollTo(0, 0);
      selectTab();
    });

    selectTab();

    // Initialize global modal
    const globalModal = document.getElementById('global-modal');
    const closeBtn = globalModal.querySelector('.global-modal__close');
    const modalOverlay = globalModal.querySelector('.global-modal__overlay');
    const modalContent = globalModal.querySelector('.global-modal__content');
    const addressesContainer = document.querySelector('.customer-info__shipping');

    const openModalWithForm = (formContainerSelector) => {
      const formContainer = document.querySelector(formContainerSelector);

      if (formContainer && modalContent) {
        const formContent = formContainer.cloneNode(true);

        const allFormFields = formContent.querySelectorAll('.field');

        allFormFields.forEach((field) => {
          const label = field.querySelector('label');
          const input = field.querySelector('input, select, textarea');
          const id = label?.htmlFor;
          if (input && label) {
            input.id = `${id}New`;
            label.htmlFor = `${id}New`;
          }
        });

        formContent.style.display = 'block';
        modalContent.innerHTML = formContent.innerHTML;
        modalContent.querySelector('.field-make-default-address label').htmlFor = 'AddressSetAsDefaultNew';
        modalContent.querySelector('.field-make-default-address input').id = 'AddressSetAsDefaultNew';
        globalModal.classList.add('global-modal--is-open');
        document.body.classList.add('page--scroll-lock');

        const selectCountry = modalContent.querySelector('select[name="address[country]"]');
        const defaultCountry = selectCountry.getAttribute('data-default') ?? null;
        if (selectCountry && defaultCountry) {
          selectCountry.value = defaultCountry;
        }

        const validateForm = () => {
          const addButton = modalContent.querySelector('.customer-info__add-address-button');
          if (selectCountry.value && selectCountry.value !== '---') {
            addButton.removeAttribute('disabled');
          } else {
            addButton.setAttribute('disabled', 'disabled');
          }
        };

        selectCountry.addEventListener('change', validateForm);
        validateForm();
      }
    };

    addressesContainer.addEventListener('click', (e) => {
      const target = e.target;

      if (target.classList.contains('customer-info__edit-button')) {
        e.preventDefault();
        const addressId = target.getAttribute('data-address-id');
        const formContainerSelector = `div[data-address-id="${addressId}"]`;

        openModalWithForm(formContainerSelector);
        e.stopPropagation;
      } else if (target.classList.contains('customer-info__add-address-button')) {
        e.preventDefault();
        openModalWithForm('.customer-info__add-address-modal');
        e.stopPropagation;
      } else {
        return;
      }

      modalContent.querySelector('.customer-info__cancel-button').addEventListener('click', (e) => {
        e.preventDefault();
        closeModal();
      });

      modalContent.querySelector('.customer-info__add-address-button').addEventListener('click', (e) => {
        e.preventDefault();
        const currentForm = modalContent.querySelector('form');
        if (currentForm) {
          const formData = new FormData(currentForm);

          fetch(currentForm.action, {
            method: currentForm.method,
            body: formData,
            headers: {
              Accept: 'text/html',
            },
          })
            .then(() => {
              updateAddresses();
              closeModal();
            })
            .catch((err) => {
              console.error(err);
              closeModal();
            });
        }
      });
    });

    const closeModal = () => {
      modalContent.innerHTML = '';
      globalModal.classList.remove('global-modal--is-open');
      document.body.classList.remove('page--scroll-lock');
    };

    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }
    if (modalOverlay) {
      modalOverlay.addEventListener('click', closeModal);
    }

    globalModal.addEventListener('click', (e) => {
      if (e.target === globalModal) {
        closeModal();
      }
    });

    // Close modal on Escape key press
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('read-more-btn');
    const excerpt = document.getElementById('article-excerpt');
    const full = document.getElementById('article-full');

    if (btn) {
      btn.addEventListener('click', function () {
        excerpt.style.display = 'none';
        full.classList.remove('hidden');
        full.classList.add('scroll-trigger', 'animate--slide-in');
        btn.style.display = 'none';

        const paragraphs = full.querySelectorAll('p');

        paragraphs.forEach((p) => {
          const children = Array.from(p.childNodes).filter(
            (node) => node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== ''
          );

          const hasImage = p.querySelector('img') !== null;
          if (!hasImage) {
            p.classList.add('text-only');
          }

          if (children.length === 1 && children[0].tagName === 'A') {
            children[0].classList.add('btn-link');
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const loadMoreBtn = document.getElementById('load-more');
    const blogContainer = document.getElementById('blog-articles');

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function (event) {
        event.preventDefault();
        const nextPageUrl = this.dataset.nextPage;
        if (!nextPageUrl) return;

        fetch(nextPageUrl)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Choose only new articles from the next page
            const newArticles = doc.querySelectorAll('#blog-articles .default-article-card');
            newArticles.forEach((article) => {
              blogContainer.appendChild(article);
              setTimeout(() => article.classList.add('default-article-card--show'), 50);
            });

            // Refresh button or hide it
            const newBtn = doc.querySelector('#load-more');

            if (newBtn && newBtn.dataset.nextPage.length) {
              loadMoreBtn.dataset.nextPage = newBtn.dataset.nextPage;
            } else {
              loadMoreBtn.remove();
            }
          })
          .catch((err) => console.error('Error loading:', err));
      });
    }
    document
      .querySelectorAll('#blog-articles .default-article-card')
      .forEach((card) => card.classList.add('default-article-card--show'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const productGrid = document.getElementById('product-grid');
    const filterButton = document.querySelector('.collection-section__filters-button');
    const filterAside = document.querySelector('#main-collection-filters');
    const filterCloseButton = document.querySelector('.aside-filters-close');
    const filterApplyButton = document.querySelector('.filters-container__apply');
    const filtersOverlay = document.querySelector('.collection-section__filters-overlay');

    const isDesktop = () => window.innerWidth >= 1030;

    const updateFilterButtonText = () => {
      if (!filterButton) return;
      const isOpen = filterAside.classList.contains('collection-section__filters-aside--open');
      filterButton.textContent = isOpen ? 'Hide filters' : 'Filters';
    };

    if (isDesktop()) {
      filterAside.style.transition = 'none';
      filterAside.classList.add('collection-section__filters-aside--open');
      filterAside.offsetHeight;
      setTimeout(() => {
        filterAside.style.transition = '';
        updateFilterButtonText();
      }, 0);
    } else {
      updateFilterButtonText();
    }

    window.addEventListener('resize', () => {
      if (isDesktop()) {
        filterAside.classList.add('collection-section__filters-aside--open');
      } else {
        filterAside.classList.remove('collection-section__filters-aside--open');
      }
      updateFilterButtonText();
    });

    filterButton.addEventListener('click', function () {
      filterAside.classList.toggle('collection-section__filters-aside--open');
      updateFilterButtonText();
    });

    const defaultButton = document.querySelector('.collection-grid-switcher__button--active');
    const defaultGridSize = defaultButton.getAttribute('data-grid');
    productGrid.className = `grid-collection product-grid grid--${defaultGridSize}`;

    const gridContainer = document.querySelector('#ProductGridContainer');

    if (!gridContainer) return;

    gridContainer.addEventListener('click', async (e) => {
      const btn = e.target.closest('.load-more-btn');
      if (!btn) return;

      btn.disabled = true;
      btn.textContent = 'Loading...';

      try {
        const res = await fetch(btn.dataset.nextUrl);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const newProducts = html.querySelectorAll('#ProductGridContainer .grid-collection > *');
        const targetGrid = gridContainer.querySelector('.grid-collection');

        newProducts.forEach((el) => targetGrid.appendChild(el));

        const newBtn = html.querySelector('.load-more-btn');
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.textContent = 'Load more';
        } else {
          btn.remove();
        }
      } catch (err) {
        console.error('Load more failed:', err);
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    });

    const closeModalFilter = () => {
      filterAside.classList.remove('collection-section__filters-aside--open');
      updateFilterButtonText();
    };

    filtersOverlay.addEventListener('click', closeModalFilter);
    filterCloseButton.addEventListener('click', closeModalFilter);
    filterApplyButton.addEventListener('click', closeModalFilter);

    const url = new URL(window.location.href);
    if (!url.searchParams.has('sort_by')) {
      url.searchParams.set('sort_by', 'manual');
      window.location.replace(url.toString());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-locations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let thumbsSwiper = new Swiper('.main-locations-section__thumbs-swiper', {
      spaceBetween: 4,
      slidesPerView: 1.2,
      freeMode: true,
      watchSlidesProgress: true,
      pagination: {
        el: document.querySelector('.main-locations-section__thumbs-swiper .swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        744: {
          slidesPerView: 1.6,
        },
        1030: {
          slidesPerView: 2,
          pagination: false,
          direction: 'vertical',
        },
      },
    });
    let mainSwiper = new Swiper('.main-locations-section__main-swiper', {
      loop: true,
      effect: 'fade',
      spaceBetween: 0,
      thumbs: {
        swiper: thumbsSwiper,
      },
      allowTouchMove: false,
      keyboard: {
        enabled: false,
      },
      mousewheel: false,
    });

    if (window.innerWidth >= 1030) {
      thumbsSwiper.slides.forEach((slide, index) => {
        slide.addEventListener('mouseenter', () => {
          mainSwiper.slideTo(index);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('hashchange', () => {
      window.scrollTo(0, 0);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.auth-section--register form');
    const privacyCheckbox = document.getElementById('RegisterForm-privacy');
    const submitButton = form.querySelector('button[type="submit"]');

    console.log(form, privacyCheckbox, submitButton);

    form.addEventListener('submit', function (event) {
      if (!privacyCheckbox.checked) {
        event.preventDefault();
        alert('You must accept the privacy policy to register.');
      }
    });

    privacyCheckbox.addEventListener('change', function () {
      submitButton.disabled = !privacyCheckbox.checked;
    });

    if (privacyCheckbox.checked) {
      submitButton.disabled = false;
    } else {
      submitButton.disabled = true;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const productGrid = document.getElementById('product-grid');
    const filterButton = document.querySelector('.collection-section__filters-button');
    const filterAside = document.querySelector('#main-search-filters');
    const filterCloseButton = document.querySelector('.aside-filters-close');
    const filterApplyButton = document.querySelector('.filters-container__apply');
    const filtersOverlay = document.querySelector('.collection-section__filters-overlay');

    const productsCountElement = document.querySelector('[data-products-count]');
    const articlesCountElement = document.querySelector('[data-articles-count]');

    const searchParams = new URLSearchParams(window.location.search);
    let filterType = searchParams.get('type') || 'product';
    console.log('filterType', filterType);

    const buttonToActivate = document.querySelector('button[data-button-type="' + filterType + '"]');
    if (buttonToActivate) {
      buttonToActivate.classList.add('template-search__tab-button--active');
    }

    const articlesCount = searchParams.get('articles') || sessionStorage.getItem('articles') || '0';
    const productsCount = searchParams.get('products') || sessionStorage.getItem('products') || '0';

    sessionStorage.setItem('articles', articlesCount);
    sessionStorage.setItem('products', productsCount);

    if (productsCountElement) {
      productsCountElement.textContent = `(${productsCount})`;
    }

    if (articlesCountElement) {
      articlesCountElement.textContent = `(${articlesCount})`;
    }

    const isDesktop = () => window.innerWidth >= 1030;

    const updateFilterButtonText = () => {
      if (!filterButton) return;
      const isOpen = filterAside.classList.contains('collection-section__filters-aside--open');
      filterButton.textContent = isOpen ? 'Hide filters' : 'Filters';
    };

    if (isDesktop()) {
      filterAside.style.transition = 'none';
      filterAside.classList.add('collection-section__filters-aside--open');
      filterAside.offsetHeight;
      setTimeout(() => {
        filterAside.style.transition = '';
        updateFilterButtonText();
      }, 0);
    } else {
      updateFilterButtonText();
    }

    window.addEventListener('resize', () => {
      if (isDesktop()) {
        filterAside.classList.add('collection-section__filters-aside--open');
      } else {
        filterAside.classList.remove('collection-section__filters-aside--open');
      }
      updateFilterButtonText();
    });

    filterButton.addEventListener('click', function () {
      filterAside.classList.toggle('collection-section__filters-aside--open');
      updateFilterButtonText();
    });

    // Initialize with the default grid size
    const defaultButton = document.querySelector('.collection-grid-switcher__button--active');
    const defaultGridSize = defaultButton.getAttribute('data-grid');
    productGrid.className = `grid-collection product-grid grid--${defaultGridSize}`;

    // Load more

    const gridContainer = document.querySelector('#ProductGridContainer');

    if (!gridContainer) return;

    gridContainer.addEventListener('click', async (e) => {
      const btn = e.target.closest('.load-more-btn');
      if (!btn) return;

      btn.disabled = true;
      btn.textContent = 'Loading...';

      try {
        const res = await fetch(btn.dataset.nextUrl);
        const text = await res.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        const newProducts = html.querySelectorAll('#ProductGridContainer .grid-collection > *');
        const targetGrid = gridContainer.querySelector('.grid-collection');

        newProducts.forEach((el) => targetGrid.appendChild(el));

        const newBtn = html.querySelector('.load-more-btn');
        if (newBtn) {
          btn.dataset.nextUrl = newBtn.dataset.nextUrl;
          btn.disabled = false;
          btn.textContent = 'Load more';
        } else {
          btn.remove();
        }
      } catch (err) {
        console.error('Load more failed:', err);
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    });

    const closeModalFilter = () => {
      filterAside.classList.remove('collection-section__filters-aside--open');
      updateFilterButtonText();
    };

    filtersOverlay.addEventListener('click', closeModalFilter);
    filterCloseButton.addEventListener('click', closeModalFilter);
    filterApplyButton.addEventListener('click', closeModalFilter);

    const url = new URL(window.location.href);
    if (!url.searchParams.has('sort_by')) {
      url.searchParams.set('sort_by', 'relevance');
      window.location.replace(url.toString());
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-logos-section"] && !Shopify.designMode) return;
  try {
    
  // Marquee animation is now handled by CSS
  // No JavaScript needed for the infinite scroll effect

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-animated-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
gsap.registerPlugin(ScrollTrigger);
const isDesktop = window.innerWidth >= 1030;

console.log('Process Animated Section Loaded', window.innerWidth);
if (isDesktop) {
const tl = gsap.timeline({
scrollTrigger: {
trigger: '.process-animated-section__container',
start: 'top top',
end: '+=100%',
scrub: true,
},
});

tl.set('.process-animated-section__personalized-service', {
position: 'static',
right: 'auto',
bottom: 0,
scale: 1,
opacity: 1,
}, '0');

tl.to('.process-animated-section__personalized-service', {
position: 'fixed',
right: 0,
scale: 1.2,
opacity: 0,
ease: 'power2.in',
duration: 0.1,
}, '0');
tl.fromTo(
'.process-animated-section__sticky',
{
width: '100%',
height: '100vh',
},
{
width: '41.7245%',
height: '100vh',
ease: 'power2',
},
'0.2'
);
}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-categories-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.process-category-section').forEach((section) => {
    const swipers = section.querySelectorAll('.process-category-swiper');

    swipers.forEach((swiperEl) => {
      new Swiper(swiperEl, {
        spaceBetween: 1,
        slidesPerView: 1.5,
        grabCursor: true,
        breakpoints: {
          744: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 2.6,
          },
          1200: {
            slidesPerView: 3,
          },
          1440: {
            slidesPerView: 4,
          },
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });

    const categoryTabs = section.querySelectorAll('.process-category-section__tab');
    const categorySliders = section.querySelectorAll('.process-category-section__slider');

    if (categoryTabs.length > 0 && categorySliders.length > 0) {
      categoryTabs[0].classList.add('tab-selected');
      categorySliders[0].classList.add('process-category-section__slider--active');
    }

    categoryTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;

        categoryTabs.forEach((t) => t.classList.remove('tab-selected'));
        tab.classList.add('tab-selected');

        categorySliders.forEach((slider) => {
          if (slider.dataset.tab === targetTab) {
            slider.classList.add('process-category-section__slider--active');
          } else {
            slider.classList.remove('process-category-section__slider--active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.related-articles-section').forEach((section) => {
    const swipers = section.querySelectorAll('.related-articles-section__slider');

    swipers.forEach((swiperEl) => {
      new Swiper(swiperEl, {
        spaceBetween: 1,
        slidesPerView: 'auto',
        grabCursor: true,

        breakpoints: {
          1030: {
            spaceBetween: 8,
          },
        },

        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-articles-section"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const thumbsSwiper = new Swiper('.slider-articles-section__swiper-1', {
      loop: false,
      spaceBetween: 4,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const mainSwiper = new Swiper('.slider-articles-section__swiper-2', {
      loop: false,
      speed: 800,
      spaceBetween: 0,
      pagination: {
        el: document.querySelector('.slider-articles-section__swiper-2 .swiper-pagination'),
        clickable: true,
      },
      effect: 'fade',
      thumbs: {
        swiper: thumbsSwiper,
      },
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      breakpoints: {
        1030: {
          autoplay: false,
          effect: 'fade',
          allowTouchMove: false,
          keyboard: {
            enabled: false,
          },
          mousewheel: false,
        },
      },
    });

    const outline = document.getElementById('thumbOutline');

    function updateOutline() {
      const activeSlide = document.querySelector('.slider-articles-section__swiper-1 .swiper-slide-thumb-active');
      const slideImageBlock = activeSlide ? activeSlide.querySelector('.slider-articles-section__image') : null;
      if (!slideImageBlock || !outline) return;

      const slideRect = slideImageBlock.getBoundingClientRect();
      const containerRect = activeSlide.closest('.slider-articles-section__swiper-1').getBoundingClientRect();

      const top = slideRect.top - containerRect.top;
      const left = slideRect.left - containerRect.left;

      outline.style.width = `${slideRect.width}px`;
      outline.style.height = `${slideRect.height}px`;
      outline.style.transform = `translate(${left}px, ${top}px)`;
    }

    updateOutline();

    thumbsSwiper.on('slideChange', updateOutline);
    mainSwiper.on('slideChange', updateOutline);

    window.addEventListener('resize', updateOutline);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-collections-section"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const thumbsSwiper = new Swiper('.slider-collections-section__swiper-1', {
      loop: false,
      spaceBetween: 4,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    });

    const mainSwiper = new Swiper('.slider-collections-section__swiper-2', {
      loop: false,
      speed: 800,
      spaceBetween: 0,
      pagination: {
        el: document.querySelector('.slider-collections-section__swiper-2 .swiper-pagination'),
        clickable: true,
      },
      effect: 'fade',
      thumbs: {
        swiper: thumbsSwiper,
      },
      loop: true,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      breakpoints: {
        1030: {
          autoplay: false,
          effect: 'fade',
          allowTouchMove: false,
          keyboard: {
            enabled: false,
          },
          mousewheel: false,
        },
      },
    });

    const outline = document.getElementById('thumbOutline');

    function updateOutline() {
      const activeSlide = document.querySelector('.slider-collections-section__swiper-1 .swiper-slide-thumb-active');
      const slideImageBlock = activeSlide ? activeSlide.querySelector('.slider-collections-section__image') : null;
      if (!slideImageBlock || !outline) return;

      const slideRect = slideImageBlock.getBoundingClientRect();
      const containerRect = activeSlide.closest('.slider-collections-section__swiper-1').getBoundingClientRect();

      const top = slideRect.top - containerRect.top;
      const left = slideRect.left - containerRect.left;

      outline.style.width = `${slideRect.width}px`;
      outline.style.height = `${slideRect.height}px`;
      outline.style.transform = `translate(${left}px, ${top}px)`;
    }

    updateOutline();

    thumbsSwiper.on('slideChange', updateOutline);
    mainSwiper.on('slideChange', updateOutline);

    window.addEventListener('resize', updateOutline);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.slider-section').forEach((section) => {
      const swipers = section.querySelectorAll('.slider-section__swiper');

      swipers.forEach((swiperEl) => {
        new Swiper(swiperEl, {
          spaceBetween: 1,
          slidesPerView: 'auto',
          grabCursor: true,
          pagination: {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.you-may-also-like-section').forEach((section) => {
    const swipers = section.querySelectorAll('.you-may-also-like-section__slider');

    swipers.forEach((swiperEl) => {
      new Swiper(swiperEl, {
        spaceBetween: 4,
        slidesPerView: 'auto',
        grabCursor: true,

        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    });

    const categoryTabs = section.querySelectorAll('.you-may-also-like-section__tab');
    const categorySliders = section.querySelectorAll('.you-may-also-like-section__slider');

    if (categoryTabs.length > 0 && categorySliders.length > 0) {
      categoryTabs[0].classList.add('tab-selected');
      categorySliders[0].classList.add('you-may-also-like-section__slider--active');
    }

    categoryTabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetTab = tab.dataset.tab;

        categoryTabs.forEach((t) => t.classList.remove('tab-selected'));
        tab.classList.add('tab-selected');

        categorySliders.forEach((slider) => {
          if (slider.dataset.tab === targetTab) {
            slider.classList.add('you-may-also-like-section__slider--active');
          } else {
            slider.classList.remove('you-may-also-like-section__slider--active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
